module.exports = __webpack_public_path__ + "static/balcombe-3ada8fb43594dabf2906206a9af45435.jpg";